import { popupSelector } from '../selectors'
import { useStateValue } from '../state_provider'
import { GeneralPopup } from './general_popup'

export const CustomLocationPopup = ({ validationSchema, children }) => {
  const {
    data: {
      location: defaultLocation,
      additional_info: defaultAdditionalInfo,
      hide_location: defaultHideLocation
    }
  } = popupSelector(useStateValue())

  const initialValues = {
    location: defaultLocation || '',
    additionalInfo: defaultAdditionalInfo || '',
    hideLocation: defaultHideLocation ? 'hidden' : 'visible'
  }

  return (
    <GeneralPopup
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {children}
    </GeneralPopup>
  )
}
